import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { toast } from 'react-toastify';

import Loader from '../../Components/Loader'
import { creditNoteService } from '../../Services'

export const AddCreditNote = () => {

    const [loader, setLoader] = useState(false)
    const [jobTokenData, setJobTokenList] = useState([]);
    const [userList, setUserList] = useState([]);

    useEffect(() => {
        getJobTokenList();
        getUserList();
    }, []);


    const getJobTokenList = () => {
        creditNoteService.getJobTokenList().then((res) => {
            if (res.status) {
                let listArry = [{ value: 'none', label: 'None' }];
                res.data.map((val) => {
                    listArry.push({
                        value: val,
                        label: val.job_token,
                        job_id: val._id,
                    });
                });
                setJobTokenList(listArry);
            }
        });
    };
    const getUserList = () => {
        creditNoteService.getUserList().then((res) => {
            if (res.status) {
                let listArry = [{ value: 'none', label: 'None' }];
                res.data.map((val) => {
                    listArry.push({
                        value: val,
                        label: val.user_email,
                        full_name: val.user_full_name,
                    });
                });
                setUserList(listArry);
            }
        });
    };

    const history = useHistory()
    const formik = useFormik({
        initialValues: {
            credit_date: '',
            user_email: '',
            user_name: '',
            job_token: '',
            job_id: '',
            credit_note_amount: 0,
            quick_book_id: '',
            amount: '',
            credit_date: '',
            comment: '',

        },
        validationSchema: Yup.object({
            credit_date: Yup.string().required('Required'),
            user_email: Yup.string().required('Required').email('Please enter valid email'),
            user_name: Yup.string().required('Required'),
            job_token: Yup.string().required('Required'),
            amount: Yup.number().required('Please enter Valid amount.'),
            credit_date: Yup.string().required('Required'),
            comment: Yup.string().required('Required')
        }),
        onSubmit: values => {
            setLoader(true)
            let postData = {
                ...values,
                user_email:values.user_email.toLowerCase(),
                credit_note: {}
            }
           
            creditNoteService.creditNoteCreate(postData).then(result => {
                if (result.status) {
                    postData.credit_note = result.data
                    creditNoteService.addCreditNote(postData).then(res => {
                        if (res.status) {
                            setLoader(false)
                            history.goBack()
                        } else {
                            setLoader(false)
                            toast.error(res.message)
                        }
                    })
                } else {
                    setLoader(false)
                }
            })

        },
    });

    const onSelect = (e) => {
        formik.setValues({
            ...formik.values,
            user_email: e.value.user_email,
            user_name: e.value.user_full_name ? e.value.user_full_name : e.val.user_name,
            quick_book_id: e.value.quickBookRef.userid
        })
    }
    const onSelectJob = (e) => {
        let amt = e.value.payment_information.credit_note_amount? e.value.payment_information.credit_note_amount:0
        formik.setValues({
            ...formik.values,
            job_token: e.value.job_token,
            job_id: e.value._id,
            credit_note_amount:amt
        })
    }
    const trackingDate = (event) => {
        formik.setValues({
            ...formik.values,
            credit_date: event.target.value
        })
    }
    return (
        <div className="row d-flex justify-content-center">
            <div className="col-lg-8">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Credit Note Date</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type='date'
                                            name='credit_date'

                                            onChange={(e) => trackingDate(e)}

                                            className={'form-control' + (formik.touched.credit_date ? !formik.errors.credit_date ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('credit_date')}
                                            placeholder="Select Date"
                                        // minLength="10"
                                        />
                                        {formik.touched.credit_date && formik.errors.credit_date ? (
                                            <div className="text-danger">{formik.errors.credit_date}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label" >Email </label>
                                    </div>
                                    <div className="col-9">
                                        <Select
                                            styles={{
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    height: 'calc(2.15rem + 2px)',
                                                    overflowY: 'visible'
                                                }),
                                                control: (provider) => ({
                                                    ...provider,
                                                    borderColor: formik.touched.user_email ? !formik.errors.user_email ? '#34c38f' : '#f46a6a' : '#ced4da',
                                                    boxShadow: '0 0 0 0px #f46a6a'
                                                }),
                                                placeholder: (provider) => ({
                                                    ...provider,
                                                    color: '#a0b0ca'
                                                })
                                            }}

                                            onChange={(e) => onSelect(e)}
                                            options={userList}
                                        />
                                        {formik.touched.user_email && formik.errors.user_email ? (
                                            <div className="text-danger">{formik.errors.user_email}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Name</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            required={false}
                                            type="text"
                                            className={'form-control' + (formik.touched.user_name ? !formik.errors.user_name ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('user_name')}
                                            placeholder="Enter Name"
                                        />
                                        {formik.touched.user_name && formik.errors.user_name ? (
                                            <div className="text-danger">{formik.errors.user_name}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Job Number </label>
                                    </div>
                                    <div className="col-9">
                                        <Select
                                            styles={{
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    height: 'calc(2.15rem + 2px)',
                                                    overflowY: 'visible'
                                                }),
                                                control: (provider) => ({
                                                    ...provider,
                                                    borderColor: formik.touched.job_token ? !formik.errors.job_token ? '#34c38f' : '#f46a6a' : '#ced4da',
                                                    boxShadow: '0 0 0 0px #f46a6a'
                                                }),
                                                placeholder: (provider) => ({
                                                    ...provider,
                                                    color: '#a0b0ca'
                                                })
                                            }}
                                            options={jobTokenData}
                                            onChange={(e) => onSelectJob(e)}

                                        />
                                        {formik.touched.job_token && formik.errors.job_token ? (
                                            <div className="text-danger">{formik.errors.job_token}</div>
                                        ) : null}
                                        {/* <input
                                            required={false}
                                            type="text"
                                            className={'form-control' + (formik.touched.job_token ? !formik.errors.job_token ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('job_token')}
                                            placeholder="Enter Job Number "
                                            minLength="10"
                                        />
                                        {formik.touched.job_token && formik.errors.job_token ? (
                                            <div className="text-danger">{formik.errors.job_token}</div>
                                        ) : null} */}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Amount</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            required={false}
                                            type="text"
                                            className={'form-control' + (formik.touched.amount ? !formik.errors.amount ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('amount')}
                                            placeholder="Enter Amount"

                                        />
                                        {formik.touched.amount && formik.errors.amount ? (
                                            <div className="text-danger">{formik.errors.amount}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Comment</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            required={false}
                                            type="text"
                                            className={'form-control' + (formik.touched.comment ? !formik.errors.comment ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('comment')}
                                            placeholder="Enter Comment"
                                            minLength="10"
                                        />
                                        {formik.touched.comment && formik.errors.comment ? (
                                            <div className="text-danger">{formik.errors.comment}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => formik.handleSubmit()}
                                >Submit</button>
                            </div>
                        </form>
                        <Loader isShow={loader} />
                    </div>
                </div>
            </div>
        </div>
    )
}
